import '@tencent/tea-component/dist/tea.css';

import { initI18nData } from 'common-translation/tools';

import en from './i18n/translation/en.json';
import zh from './i18n/translation/zh.json';
import * as Google from './src/modules/google';
import { login } from './src/modules/login';

export { Google, login };

// 初始化i18n
(() => {
  initI18nData({
    lang: 'en',
    ns: ['portal-common-account'],
    resources: {
      en: {
        'portal-common-account': en,
      },
      zh: {
        'portal-common-account': zh,
      },
    },
  });
})();
